import { useEffect } from "react";
import { FiCheckCircle, FiX } from "react-icons/fi";

export default function Notification({
  message,
  type = "success", // success | error | info
  onClose,
  duration = 3000
}) {
  useEffect(() => {
    if (!message) return;

    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  const styles = {
    success: "bg-green-600",
    error: "bg-red-600",
    info: "bg-blue-600"
  };

  return (
<div className="fixed top-5 left-1/2 -translate-x-1/2 z-50 w-[80%] sm:w-auto max-w-3xl animate-slideDown">
  <div
    className={`flex items-center gap-3 text-white px-6 py-3 rounded-lg shadow-lg text-sm ${styles[type]}`}
  >
    <FiCheckCircle className="text-lg" />
    <span className="flex-1 break-words">{message}</span>

    <button onClick={onClose} className="ml-4 opacity-80 hover:opacity-100">
      <FiX />
    </button>
  </div>
</div>

  );
}
